const n = (o) => {
  let s = {
    isUploading: !1,
    progress: 0,
    total: 0,
    isUploaded: !1
  };
  const e = () => {
    o == null || o(s);
  }, l = () => {
    s = {
      ...s,
      progress: 0,
      total: 0,
      isUploading: !0,
      isUploaded: !1
    }, e();
  }, d = () => {
    s = {
      ...s,
      isUploading: !1,
      isUploaded: !0
    }, e();
  }, a = (t, r) => {
    r && (s = {
      ...s,
      progress: Math.round(t * 100 / r),
      total: r
    }, e());
  };
  return {
    getState: () => s,
    startProgress: l,
    finishProgress: d,
    updateProgress: a,
    resetProgress: () => {
      s = {
        progress: 0,
        total: 0,
        isUploading: !1,
        isUploaded: !1
      }, e();
    },
    progressHandler: (t) => {
      const r = t.loaded, p = t.total;
      a(r, p);
    }
  };
};
export {
  n as createProgress
};
